import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      marginBlock: 0,
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    error: {},
  })
);

enum TypeSize {
  small = "small",
  medium = "medium",
}

type SimpleSelectProps = {
  id: string;
  label: string;
  value: any;
  inputProps?: any;
  onChange: (value: string) => void;
  items: any[];
  errors: any;
  size?: TypeSize;
  required?: boolean;
  disabled?: boolean;
};

const SimpleSelect = ({
  id,
  label,
  value,
  onChange,
  items,
  inputProps,
  errors,
  size,
  disabled,
  required,
}: SimpleSelectProps) => {
  const classes = useStyles();
  return (
    <>
      <FormControl
        className={classes.formControl}
        variant="outlined"
        fullWidth
        disabled={disabled}
        required={required}
        size={size ? size : TypeSize.medium}
      >
        <InputLabel id={id}>{label}</InputLabel>
        <Select
          labelId={id}
          id={id}
          name={id}
          value={value}
          inputProps={inputProps}
          onChange={(e: any) => onChange(e.target.value)}
          label={label}
        >
          {items.map((item, index) => (
            <MenuItem key={index} value={item.value || item.code}>
              {item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {errors ? <p className={classes.error}>{errors}</p> : null}
    </>
  );
};

export default SimpleSelect;
